import { RobotDashboard } from 'app/modules/cleaning/widgets/robot-dashboard/components/RobotDashboard/RobotDashboard';

export const RobotDashboardPage = (): JSX.Element => <RobotDashboard />;
